import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import './PageLoader.css';

gsap.registerPlugin(useGSAP);

function PageLoader({ onComplete }) {
  const scope = useRef(null);
  useGSAP(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const media = gsap.matchMedia();
    media.add({ reduce: '(prefers-reduced-motion: reduce)', animate: '(prefers-reduced-motion: no-preference)' }, ({ conditions }) => {
      if (conditions.reduce) {
        onComplete();
        return;
      }
      gsap.timeline({ onComplete, defaults: { ease: 'power3.out' } })
        .from('.page-loader__logo', { opacity: 0, scale: 0.85, duration: 0.45 }, 0)
        .from('.page-loader__line span', { scaleX: 0, transformOrigin: 'left', duration: 0.7 }, 0.25)
        .to(scope.current, { yPercent: -100, duration: 0.45 }, 1.1);
    });
    return () => {
      media.revert();
      document.body.style.overflow = previousOverflow;
    };
  }, { scope, dependencies: [onComplete] });

  return (
    <div ref={scope} className="page-loader" role="status" aria-label="Loading JamRock Escape">
      <img className="page-loader__logo" src={`${process.env.PUBLIC_URL}/images/logo.jpg`} width="220" height="147" alt="JamRock Escape" />
      <div className="page-loader__line" aria-hidden="true"><span /></div>
    </div>
  );
}
export default PageLoader;
